import React from 'react';

const Label = ({
  onClick,
  onKeyPress,
  ...restProps
}) => {
  if (onClick && !onKeyPress) {
    onKeyPress = (e) => {
      if (e.key === ' ') {
        e.preventDefault();
        onClick(e);
      }
    };
  }

  return (
    <label tabIndex={0} onClick={onClick} onKeyPress={onKeyPress} {...restProps} />
  );
};

export default Label;



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/Label.js